"use client";

import { X } from "lucide-react";
import Link from "next/link";
import { useEffect, useState } from "react";

import { Button } from "~/components/ui/button";
import { Card, CardContent } from "~/components/ui/card";

export function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const cookieConsent = localStorage.getItem("cookieConsent");
    if (!cookieConsent) {
      setIsVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookieConsent", "true");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed right-0 bottom-0 left-0 z-50 bg-white/80 p-4 backdrop-blur-sm">
      <Card>
        <CardContent className="flex items-center justify-between p-4">
          <div className="flex-1 pr-4">
            <p className="text-sm text-slate-600">
              We use cookies to improve your experience on our website. By continuing to use
              this site, you agree to our use of cookies. For more information, please see
              our{" "}
              <Link
                href="https://www.eurac.edu/privacy-policy"
                className="text-blue-600 hover:underline"
              >
                Privacy Policy
              </Link>
              .
            </p>
          </div>
          <div className="flex items-center gap-2">
            <Button onClick={acceptCookies} variant="default" size="sm">
              Accept
            </Button>
            <Button onClick={() => setIsVisible(false)} variant="ghost" size="icon">
              <X className="h-4 w-4" />
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
